import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import './index.css';
import App from './App';
import store from './stores';
import { LocaleProvider } from 'antd';
import fr_FR from 'antd/lib/locale-provider/fr_FR';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <LocaleProvider locale={fr_FR}>
    <Provider { ...store }>
      <App />
    </Provider>
  </LocaleProvider>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js